const translation = {
  pageTitle: 'Salut, commençons !👋',
  welcome: 'Bienvenue sur Dify, veuillez vous connecter pour continuer.',
  email: 'Adresse e-mail',
  emailPlaceholder: 'Votre email',
  password: 'Mot de passe',
  passwordPlaceholder: 'Votre mot de passe',
  name: 'Nom d\'utilisateur',
  namePlaceholder: 'Votre nom d\'utilisateur',
  forget: 'Mot de passe oublié ?',
  signBtn: 'Se connecter',
  installBtn: 'Mettre en place',
  setAdminAccount: 'Configuration d\'un compte administrateur',
  setAdminAccountDesc: 'Privilèges maximum pour le compte administrateur, qui peut être utilisé pour créer des applications et gérer les fournisseurs de LLM, etc.',
  createAndSignIn: 'Créer et se connecter',
  oneMoreStep: 'Une étape de plus',
  createSample: 'Sur la base de ces informations, nous créerons une application exemple pour vous',
  invitationCode: 'Code d\'invitation',
  invitationCodePlaceholder: 'Votre code d\'invitation',
  interfaceLanguage: 'Langue de l\'interface',
  timezone: 'Fuseau horaire',
  go: 'Aller à Dify',
  sendUsMail: 'Envoyez-nous votre introduction, et nous nous occuperons de la demande d\'invitation.',
  acceptPP: 'J\'ai lu et j\'accepte la politique de confidentialité',
  reset: 'Veuillez exécuter la commande suivante pour réinitialiser votre mot de passe',
  withGitHub: 'Continuer avec GitHub',
  withGoogle: 'Continuer avec Google',
  rightTitle: 'Débloquez le plein potentiel des LLM',
  rightDesc: 'Construisez sans effort des applications IA visuellement captivantes, opérationnelles et améliorables.',
  tos: 'Conditions de Service',
  pp: 'Politique de Confidentialité',
  tosDesc: 'En vous inscrivant, vous acceptez nos',
  goToInit: 'Si vous n\'avez pas initialisé le compte, veuillez vous rendre sur la page d\'initialisation',
  donthave: 'Vous n\'avez pas ?',
  invalidInvitationCode: 'Code d\'invitation invalide',
  accountAlreadyInited: 'Compte déjà initialisé',
  error: {
    emailEmpty: 'Une adresse e-mail est requise',
    emailInValid: 'Veuillez entrer une adresse email valide',
    nameEmpty: 'Le nom est requis',
    passwordEmpty: 'Un mot de passe est requis',
    passwordInvalid: 'Le mot de passe doit contenir des lettres et des chiffres, et la longueur doit être supérieure à 8.',
  },
  license: {
    tip: 'Avant de commencer Dify Community Edition, lisez le GitHub',
    link: 'Licence Open-source',
  },
  join: 'Rejoindre',
  joinTipStart: 'Je vous invite à rejoindre',
  joinTipEnd: 'équipe sur Dify',
  invalid: 'Le lien a expiré',
  explore: 'Explorez Dify',
  activatedTipStart: 'Vous avez rejoint le',
  activatedTipEnd: 'équipe',
  activated: 'Connectez-vous maintenant',
  adminInitPassword: 'Mot de passe d\'initialisation de l\'administrateur',
  validate: 'Valider',
}

export default translation
